export function sortString (previous, next) {
  return previous.localeCompare(next, undefined, { sensitivity: 'base' });
}

export function sortByProperty (property) {
  return (previous, next) => sortString(previous[property], next[property]);
}
